export const createReportRun = `
    mutation createReportRun($input: CreateReportRunInput!) {
        createReportRun(input:$input) {
            id
            created
            reportType
            status
    }
}`;
